import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface MainLayoutStore {
  expandedDesktop: boolean;
  setExpandedDesktop: (expandedDesktop: boolean) => void;
  openMobile: boolean;
  setOpenMobile: (openMobile: boolean) => void;
}

const useMainLayoutStore = create<MainLayoutStore>()(
  persist(
    (set) => ({
      expandedDesktop: true,
      setExpandedDesktop: (expandedDesktop: boolean) => set({ expandedDesktop }),
      openMobile: false,
      setOpenMobile: (openMobile: boolean) => set({ openMobile }),
    }),
    {
      name: 'mainLayoutStore',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        expandedDesktop: state.expandedDesktop,
      }),
    },
  ),
);

export { useMainLayoutStore };
